<template>
  <router-link
    class="btn btn-primary"
    :class="data.class"
    :to="{ name: data.componentName, params: param }"
    :title="data.text"
  >
    <i :class="data.icon" aria-hidden="true" />{{ data.text }}
  </router-link>
</template>
<script>
export default {
  name: "volcan-add-btn",
  props: ["data"],
  data: function () {
    return {};
  },
  mounted: function () {},
  computed: {
    param() {
      var param = {};

      if (this.data.paramPropertiesStatic != undefined) {
        this.data.paramPropertiesStatic.forEach((item) => {
          param[item.key] = item.name;
        });
      }

      return param;
    },
  },
  watch: {},
  methods: {},
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/divers/add-btn.vue